<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: 'batchList' }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
        </p>
        <h1 v-translate>Detail importu registrovaných MAC adres</h1>
      </div>

      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <detail-entity-info :entity="entity"></detail-entity-info>
            </div>
            <div class="right">
              <textarea-input id="macaddressdescription"
                              :required="true"
                              v-model="entity.description"
                              :disabled="true"
                              ref="macaddressdescriptionref"
              >
                <translate class="translate">Popis</translate>
              </textarea-input>
              <p>&nbsp</p>
                <div class="filter">
                  <div class="field_left">
                    <search-input input-class="search" v-model="formFields.search"></search-input>
                  </div>
                  <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
                </div>
              <form>
                <div class="table_overflow" id="contentBox" data-table-id="registered-mac-address-batch-detail">
                  <table class="vypis" ref="table_with_action_line">
                <thead>
                <tr>
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in macAddressTableTitles"
                    :key="title.id"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                </tr>
                </thead>
                <tbody>
                <mac-address-row
                    v-for="macAddress in entities"
                    :entity="macAddress"
                    :key="macAddress.id"
                    :selectedEntities="selectedEntities"
                    @input="select"
                />
                </tbody>
              </table>
                </div>
                <list-action-line
                    :entities="entities"
                    :selected-entities="filteredSelectedEntities"
                    :multiple-action-options="multipleActionOptions"
                    table-id="registered-mac-address-batch-detail"
                    @select-all="toggleSelectAll"
                    @run-multiple-action="runMultipleAction"
                    :total-count="totalCount"
                    @limit="setLimit"
                    @offset="setOffset"
                    :offset="formFields.offset"
                    :limit="formFields.limit"
                ></list-action-line>
              </form>
            </div>
          </section>
        </div>
      </div>
  </div>
</template>

<script>
import MacAddressRow from "./RegisteredMacAddressBatchDetailMacAddressRow";
import detailActions from "@/components/mixins/detail-actions";
import listActions from "@/components/mixins/list-actions"

export default {
  name: "registeredMacAddressBatch",
  components: {MacAddressRow},
  mixins: [listActions, detailActions],
  data() {
    return {
      entityName: 'registeredMacAddressBatch',
      moduleName: 'registeredMacAddressBatch',
      formFields: {
        sort: {
          column: 'sMacAddress',
          direction: 'desc',
        },
      },
    }
  },
  created(RegisteredMacAddressBatchService) {
    this.entityService = RegisteredMacAddressBatchService
    this.loadDefaults();
    this.createdInit()
        .then(() => {
          this.entities = this.entity.mac_addresses;
          this.totalCount = this.entity.mac_addresses_count;
        });
  },
  methods: {
    getEntities(){
      this.setLoadingMessage()
      return this.entityService.getEntity(this.$route.params.id, this._processFormFields(this.getFormFields()))
          .then(data => {
            this.emptyMessage()
            this.entity = data[this.entityName]
            this.entities = this.entity.mac_addresses;
            this.totalCount = this.entity.mac_addresses_count;
          })
          .catch(function (error) {
            this.setErrorMessage(error['error_message'])

          }.bind(this));
    },
    _exportCsv(){
      this.setLoadingMessage()
      let formFields = this._processFormFields(this.getFormFields());
      delete formFields.limit;
      delete formFields.offset;
      this._createExportCsv(this.csvHeaders, this.entities);
    },
  },
  computed: {
    macAddressTableTitles() {
      return [
        {id: 1, name: this.$gettext('MAC Adresa'), column: 'sMacAddress'}
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
      ];
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.macAddressTableTitles);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/RegisteredMacAddressBatchDetail.vue